<template>
  <vuetify-aggregator-card
    ref="aggregator"
    :color="color"
    :toolbar-title="toolbarTitle"
    :list-title="listTitle"
    :add-button-hover-text="addButtonHoverText"
    :dialog-max-width="dialogMaxWidth"
    :dialog-toolbar-title="dialogToolbarTitle"
  >
    <v-list two-line slot="card-text" v-if="items.length > 0">
      <transition-group name="list" tag="span">
        <template v-for="(item, index) in items">
          <v-list-tile :key="(index + 2 * 100)">
            <v-list-tile-action>

                <v-btn slot="activator" icon flat color="primary">
                  <v-icon>store</v-icon>
                </v-btn>

            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.commerce_name}}</v-list-tile-title>
              <v-list-tile-sub-title>{{ item.company_name }} - {{ item.business_name }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-tooltip bottom>
                <v-btn slot="activator" icon flat color="primary" @click="askForConfirmation(index)">
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>{{ deleteIconHoverText }}</span>
              </v-tooltip>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="index + 1 !== items.length" :inset="false" :key="(index + 1 * 100)"></v-divider>
        </template>
      </transition-group>
    </v-list>
  
    <div slot="dialog-card-text"
    class="select-commerce-card">
      <v-layout column align-center justify-center>
          <v-select
            v-model="businessSelected"
            :items="businessSelect"
            label="Grupo empresarial"
            :disabled="businessSelect.length === 0"
          ></v-select>

          <v-select
            v-model="companySelected"
            :items="companiesSelect"
            label="Empresa"
            :disabled="companiesSelect.length === 0"
          ></v-select>

          <v-select
            v-model="commerceSelected"
            :items="commercesSelect"
            label="Comercio"
            :disabled="commercesSelect.length === 0"
          ></v-select>
      </v-layout>
    </div>
    
    <div slot="dialog-card-actions">
      <v-btn
        color="indigo"
        flat
        @click.native="closeDialog()"
      >
        Cancelar
      </v-btn>
      <v-btn
        color="indigo"
        flat
        :disabled="!this.commerceSelected"
        @click.native="addCommerce()"
      >
        Aceptar
      </v-btn>
    </div>

    <vuetify-dialog-confirm
      slot="extras"
      :headline="dialogConfirmHeadline"
      :text="dialogConfirmText"
      :cancel="cancelButton"
      :confirm="confirmButton"
      @on-cancel-dialog="onDiscardDeletion"
      @on-confirm-dialog="onConfirmDeletion"
      v-model="showConfirmDialog"
    ></vuetify-dialog-confirm>
<pre>
  {{items}}
</pre>
  </vuetify-aggregator-card>
</template>

<script>
  'use strict'

  import VuetifyAggregatorCard from '@/layouts/vuetify-aggregator-card'
  import VuetifyDialogConfirm from '@/components/vuetify-dialog-confirm'
  import VuetifyFormCreator from '@/components/vuetify-form-creator/vuetify-form-creator'
  import VueGoogleAutocomplete from 'vue-google-autocomplete'

  export default {

    name: 'VuetifyCommerceAggregator',

    components:
    {
      VuetifyAggregatorCard,
      VuetifyDialogConfirm,
      VuetifyFormCreator,
      VueGoogleAutocomplete
    },

    props: {
      commerces: {
        default: null,
        required: true
      },
      commercesList: {
        type: Array,
        default: () => [],
        required: true
      },
      color: {
        type: String,
        default: 'primary',
        required: false
      },
      toolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      listTitle: {
        type: String,
        default: null,
        required: true
      },
      addButtonHoverText: {
        type: String,
        default: null,
        required: true
      },
      dialogMaxWidth: {
        type: Number,
        default: 350,
        required: false
      },
      dialogToolbarTitle: {
        type: String,
        default: null,
        required: true
      },
      dialogConfirmHeadline: {
        type: String,
        default: 'Delete commerce',
        required: false
      },
      dialogConfirmText: {
        type: String,
        default: '¿Delete commerce?',
        required: false
      },
      cancelButton: {
        type: String,
        default: 'Cancel',
        required: false
      },
      confirmButton: {
        type: String,
        default: 'Confirm',
        required: false
      },
      deleteIconHoverText: {
        type: String,
        default: 'Delete',
        required: false
      },
      locationIconHoverText: {
        type: String,
        default: 'Delete',
        required: false
      },
      value: {
        default: null
      }
    },

    data: () => ({
      items: [],
      dialog: false,
      valid: false,
      showConfirmDialog: false,
      currentIndex: 0,
      types: null,
      businessSelect: [],
      businessSelected: null,
      companiesSelect: [],
      companySelected: null,
      commercesSelect: [],
      commerceSelected: null,
      phoneType: null,
      phoneNumber: null,
      humanizeDuration: require('humanize-duration'),
      address: {
        dialog: false,
        data: null
      },
      commerce: {
        current: {
          id: 0,
          index: 0
        },
        dialog: false,
        iframe: {
          dialog: false
        },
        visible: false,
        form: [
          {
            ref: '',
            type: 'radio-group',
            label: 'Selecciona el área a habilitar:',
            columns: 'xs12 sm12 md12 lg12',
            value: '',
            class: 'commerce-radio-group',
            itemText: 'quantity_value',
            itemValue: 'quantity_id',
            avatars: false,
            options: [
              {
                value: 'commerce_postal_code',
                visible: false,
                label: '',
                hint: ''
              },
              {
                value: 'commerce_locality',
                visible: false,
                label: '',
                hint: ''
              },
              {
                value: 'commerce_province',
                visible: false,
                label: '',
                hint: ''
              },
              {
                value: 'commerce_distance',
                visible: false,
                label: '',
                hint: ''
              },
              {
                value: 'commerce_duration',
                visible: false,
                label: '',
                hint: ''
              }
            ],
            rules: [],
            required: true,
            autocomplete: true,
            disabled: false,
            chips: true
          },
          {
            ref: 'distance',
            type: 'slider',
            label: 'Distancia',
            columns: 'xs12 sm12 md12 lg12',
            visible: false,
            value: 10,
            min: 1,
            max: 1000
          },
          {
            ref: 'duration',
            type: 'slider',
            label: 'Tiempo',
            columns: 'xs12 sm12 md12 lg12',
            visible: false,
            value: 3600000,
            step: 60000,
            min: 60000,
            max: 86400000
          }
        ],
        distance: 0
      }
    }),

    created () {
      if (this.commerces.length > 0) {
        this.normalizeCommerces(this.commerces)
      }
    },

    watch: {
      commerces: {
        handler: function (newVal, oldVal) {
          this.normalizeCommerces(newVal)
        },
        deep: true
      },
      commercesList: {
        handler: function (newVal, oldVal) {
          this.normalizeCommerces(newVal)
          this.getBusiness()
        },
        deep: true
      },
      businessSelected: {
        handler: function (newVal, oldVal) {
          this.getCompanies()
        },
        deep: true
      },
      companySelected: {
        handler: function (newVal, oldVal) {
          this.getCommerces()
        },
        deep: true
      },

      items: {
        handler: function (newVal, oldVal) {
          // this.$emit('update:value', newVal)
        },
        deep: true
      },
      'commerce.form.0.value': {
        handler: function (newVal, oldVal) {
          console.log(newVal)
          this.commerce.form[1].visible = false
          this.commerce.form[2].visible = false
          if (newVal === 'commerce_distance') {
            this.commerce.form[1].visible = true
          } else if (newVal === 'commerce_duration') {
            this.commerce.form[2].visible = true
          }
        },
        deep: true
      },
      'commerce.form.1.value': {
        handler: function (newVal, oldVal) {
          this.address.data.distance = newVal
        },
        deep: true
      },
      'commerce.form.2.value': {
        handler: function (newVal, oldVal) {
          this.address.data.duration = newVal
        },
        deep: true
      }
    },

    methods: {

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onChange () {
        this.updateAreaOptions()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      openExternalMap (url) {
        window.open(url, '_blank')
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onFocusAutocomplete: function (ref) {
        // this.$refs[ref].clear()
        // this.address.data = null
        // this.commerce.form[0].value = null
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      normalizeCommerces () {
        let commerces = []
        for (let i = 0; i < this.commerces.length; i++) {
          let commerceId = parseInt(this.commerces[i] || 0)

          let index = this.commercesList.findIndex(
            item => parseInt(item.commerce_id) === commerceId
          )

          let commerce = this.commercesList[index] || null

          if (commerce) {
            commerces.push(commerce)
          }
        }
        this.items = commerces
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getBusiness () {
        let business = []
        this.commercesList.forEach((commerce) => {
          let index = business.findIndex(
            item => parseInt(item.value) === parseInt(commerce.business_id)
          )

          if (index === -1) {
            business.push({
              text: commerce.business_name,
              value: commerce.business_id
            })
          }
        })
        this.businessSelect = business.sort((a, b) => a.text - b.text)
        this.companySelected = null
        this.companiesSelect = []
        this.commerceSelected = null
        this.commercesSelect = []
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCompanies () {
        let companies = []
        this.commercesList.forEach((commerce) => {
          if (parseInt(commerce.business_id) === parseInt(this.businessSelected)) {
            let index = companies.findIndex(
              item => parseInt(item.value) === parseInt(commerce.company_id)
            )

            if (index === -1) {
              companies.push({
                text: commerce.company_name,
                value: commerce.company_id
              })
            }
          }
        })
        this.companiesSelect = companies.sort((a, b) => a.text - b.text)
        this.commerceSelected = null
        this.commercesSelect = []
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      getCommerces () {
        let commerces = []
        this.commercesList.forEach((commerce) => {
          if (parseInt(commerce.company_id) === parseInt(this.companySelected)) {
            let index = commerces.findIndex(
              item => parseInt(item.value) === parseInt(commerce.commerce_id)
            )

            if (index === -1) {
              commerces.push({
                text: commerce.commerce_name,
                value: commerce.commerce_id
              })
            }
          }
        })
        this.commercesSelect = commerces.sort((a, b) => a.text - b.text)
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      addCommerce () {
        if (this.commerces.indexOf(parseInt(this.commerceSelected)) === -1) {
          this.commerces.push(this.commerceSelected)
          this.normalizeCommerces()
          this.$emit('on-add-commerce', this.commerces)
        }
        this.closeDialog()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      closeDialog () {
        this.$refs.aggregator.dialog = false
        this.businessSelected = null
        this.companySelected = null
        this.companiesSelect = []
        this.commerceSelected = null
        this.commercesSelect = []
      },

      /**
       * When the location found
       * @param {Object} addressData Data of the found location
       * @param {Object} placeResultData PlaceResult object
       * @param {String} id Input container ID
       */
      getAddressData: function (addressData, placeResultData, id) {
        this.address.data = {
          route: addressData.route || '',
          postalCode: addressData.postal_code || '',
          locality: addressData.locality || '',
          province: addressData.administrative_commerce_level_2 || '',
          country: addressData.country || '',
          latitude: addressData.latitude || '',
          longitude: addressData.longitude || '',
          formattedAddress: placeResultData.formatted_address || '',
          url: placeResultData.url || '',
          distance: this.commerce.form[1].value || '',
          duration: this.commerce.form[2].value || '',
          placeID: placeResultData.place_id || ''
        }
        let number = addressData.street_number || ''
        number = number ? ', ' + number : ''
        this.address.data.route += number
        this.updateAreaOptions()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      updateAreaOptions () {
        if (!this.address.data) {
          return
        }
        if (this.address.data.postalCode !== '') {
          this.commerce.form[0].options[0].label = this.address.data.postalCode + ' (código postal)'
          this.commerce.form[0].options[0].hint = 'Todo el código postal ' + this.address.data.postalCode + '.'
          this.commerce.form[0].options[0].visible = true
        } else {
          this.commerce.form[0].options[0].visible = false
        }
        if (this.address.data.locality !== '') {
          this.commerce.form[0].options[1].label = this.address.data.locality + ' (localidad)'
          this.commerce.form[0].options[1].hint = 'Toda localidad de ' + this.address.data.locality + '.'
          this.commerce.form[0].options[1].visible = true
        } else {
          this.commerce.form[0].options[1].visible = false
        }
        if (this.address.data.province !== '') {
          this.commerce.form[0].options[2].label = this.address.data.province + ' (provincia)'
          this.commerce.form[0].options[2].hint = 'Toda la provincia de ' + this.address.data.province + '.'
          this.commerce.form[0].options[2].visible = true
        } else {
          this.commerce.form[0].options[2].visible = false
        }
        if (this.address.data.placeID !== '') {
          this.commerce.form[0].options[3].label = this.address.data.distance + ' Km (distancia)'
          this.commerce.form[0].options[3].hint = 'Trayectos a una distancia máxima de ' + this.commerce.form[1].value + ' Km conduciendo desde esta ubicación.'
          this.commerce.form[0].options[3].visible = true
        } else {
          this.commerce.form[0].options[3].visible = false
        }
        if (this.address.data.placeID !== '') {
          let time = this.humanizeDuration(
            this.address.data.duration, {
              language: 'es',
              round: true,
              units: ['d', 'h', 'm'],
              delimiter: ' y '
            }
          )
          this.commerce.form[0].options[4].label = time + ' (duración)'
          this.commerce.form[0].options[4].hint = 'Trayectos de una duración máxima de ' + time + ' conduciendo desde la ubicación seleccionada.'
          this.commerce.form[0].options[4].visible = true
        } else {
          this.commerce.form[0].options[4].visible = false
        }
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      askForConfirmation (index) {
        this.currentIndex = index
        this.showConfirmDialog = true
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onDiscardDeletion (ref) {
        this.showConfirmDialog = false
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      onConfirmDeletion () {
        this.showConfirmDialog = false
        this.deleteArea()
      },

      /**
       * Get theme style.
       *
       * @param {Object} obj
       * @param {String} index
       *
       * @return {*}
       */
      deleteArea () {
        if (this.commerces.length > 1) {
          this.items.splice(this.currentIndex, 1)
          this.commerces.splice(this.currentIndex, 1)
          this.$emit('on-add-commerce', this.commerces)
        } else {
          this.$awn.warning('Al menos un comercio debe estar asignado a este encargado.')
        }
      }
    }
  }
</script>

<style lang="sass">

.commerce-radio-group
  margin-bottom: -49px
  margin-top: 7px !important

.commerce-actions
  margin: 15px 0 -65px 0

.commerce-actions-card
  margin: 15px 0 9px 0

.commerce-options
  margin-top: -47px

.commerce-buttom
  bottom: 18px !important

.commerce-autocomplete
  margin: 0 auto
  padding: 16px 16px 32px 16px

.fade
  &-enter-active, &-leave-active, &-leave-to
    transition: .3s ease-out
    position: absolute
    top: 0
    left: 0

  &-enter, &-leave, &-leave-to
    opacity: 0

.list-item
  display: inline-block
  margin-right: 10px

.list-enter-active, .list-leave-active
  transition: all 1s

.list-enter, .list-leave-to
  opacity: 0
  transform: translateY(30px)
</style>


// WEBPACK FOOTER //
// src/components/vuetify-commerce-aggregator.vue